import script from "./ProjectAccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAccess.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAccess.vue?vue&type=style&index=0&id=1740840e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1740840e"]])

export default __exports__